import { useState } from 'react';
import { useRouter } from 'next/router';

import { SubscriptionPackage } from '@bpm-web-app/supreme-api-sdk';
import { getDefaultLibrary } from './helpers';

const options = [
    {
        title: 'Open Format',
        id: SubscriptionPackage.LibraryEnum.Music,
        description: 'An Open Format subscription provides download access to top genres like hip hop, R&B, pop, dance, and more, plus DJ-ready exclusives, edits, and remixes.',
    },
    {
        title: 'Latino + Global',
        id: SubscriptionPackage.LibraryEnum.Latin,
        description: 'A Latino+Global gives you top Latin genres plus exclusive remixes and worldwide trending music from Africa, the Caribbean, Asia, and beyond.',
    },
];

export const featuresData = {
    supreme: {
        standard: ['50,000+ Popular Tracks', 'Exclusive DJ-Ready Versions', 'Starter Pack Playlists', 'DJ Tutorials & Masterclasses', 'Create Your Own Playlists'],
        premium: ['75,000+ Popular Tracks', '12,000+ Exclusive Remixes', '300+ Popular Playlists', 'Dozens of Curated DJ Sets', 'Make Collaborative Playlists'],
        all: ['125,000+ Tracks', '30,000+ Exclusive Remixes', '700+ Pro Playlists', 'Unified Search Experience', { label: 'Plus Royalty-Free Loops & Samples', color: '#C9DE4A' }],
    },
    create: {
        standard: ['100 Credits Monthly', 'Access to 15 Drives', { label: 'Collaborative Drives', included: false }],
        premium: ['250 Credits Monthly', 'Access to 30 Drives', 'Collaborative Drives'],
        premiumplus: ['450 Credits Monthly', 'Access to 40 Drives', 'Collaborative Drives'],
    },
};

export const libraryFeaturesData = {
    supreme: {
        openFormat: {
            standard: {
                listTitle: 'Start building your catalog with…',
                features: ['50,000+ Popular Tracks', 'Exclusive DJ-Ready Versions', 'Starter Pack Playlists', 'DJ Tutorials & Masterclasses', 'Create Your Own Playlists'],
            },
            premium: {
                listTitle: 'Get everything in standard, plus…',
                features: ['75,000+ Popular Tracks', '12,000+ Exclusive Remixes', '300+ Popular Playlists', 'Dozens of Curated DJ Sets', 'Make Collaborative Playlists'],
            },
        },
        latin: {
            standard: {
                listTitle: 'Start building your catalog with…',
                features: ['40,000+ Latin & Global Tracks', 'Exclusive DJ-Ready Versions', 'Starter Pack Playlists', 'DJ Tutorials & Masterclasses', 'Create Your Own Playlists'],
            },
            premium: {
                listTitle: 'Get everything in standard, plus…',
                features: ['70,000+ Latin & Global Tracks', '18,000+ Exclusive Remixes', '300+ Latin & Global Playlists', 'Dozens of Curated DJ Sets', 'Make Collaborative Playlists'],
            },
        },
        all: {
            listTitle: 'Or unlock everything we offer…',
            features: ['125,000+ Tracks', '30,000+ Exclusive Remixes', '700+ Pro Playlists', 'Unified Search Experience', { label: 'Plus Royalty-Free Loops & Samples', color: '#C9DE4A' }],
        },
    },
};

export const useLibraryData = () => {
    const { query } = useRouter();
    // eslint-disable-next-line @typescript-eslint/dot-notation
    const [library, setLibrary] = useState<SubscriptionPackage.LibraryEnum>(getDefaultLibrary(options, query['library']));

    return {
        library,
        setLibrary,
        options,
        selected: options.find((o) => o.id === library),
    };
};
